export default "__VITE_ASSET__CfNqa$0M__"